var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.character ? _c('div', {
    staticClass: "pa-4"
  }, [_c('KeyValue', {
    attrs: {
      "k": _vm.$t('No Character')
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "hidden-sm-and-up"
  }, [_vm.character.isWeaken ? _c('KeyValue', {
    staticClass: "pl-4 pr-2 pt-2 float-left",
    attrs: {
      "k": _vm.$t('Distributed Weaken')
    }
  }) : _vm.character.isDistributed ? _c('KeyValue', {
    staticClass: "pl-4 pr-2 pt-2 float-left",
    attrs: {
      "k": _vm.$t('Distributed')
    }
  }) : _vm.character.isPeriodLimited ? _c('KeyValue', {
    staticClass: "pl-4 pr-2 pt-2 float-left",
    attrs: {
      "k": _vm.$t('Period Limited')
    }
  }) : _vm._e(), _c('p', {
    staticClass: "display px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$name(_vm.character.m_Name, true)))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$i18n.locale != 'ja',
      expression: "$i18n.locale!='ja'"
    }],
    staticClass: "px-4"
  }, [_c('span', [_vm._v("日本語：")]), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.character.m_Name))])])], 1), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "8",
      "xl": "6"
    }
  }, [_c('div', {
    staticClass: "hidden-xs-only"
  }, [_vm.character.isWeaken ? _c('KeyValue', {
    staticClass: "pl-4 pr-2 pt-2 float-left",
    attrs: {
      "k": _vm.$t('Distributed Weaken')
    }
  }) : _vm.character.isDistributed ? _c('KeyValue', {
    staticClass: "pl-4 pr-2 pt-2 float-left",
    attrs: {
      "k": _vm.$t('Distributed')
    }
  }) : _vm.character.isPeriodLimited ? _c('KeyValue', {
    staticClass: "pl-4 pr-2 pt-2 float-left",
    attrs: {
      "k": _vm.$t('Period Limited')
    }
  }) : _vm._e(), _c('p', {
    staticClass: "display px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$name(_vm.character.m_Name, true)))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$i18n.locale != 'ja',
      expression: "$i18n.locale!='ja'"
    }],
    staticClass: "px-4"
  }, [_c('span', [_vm._v("日本語：")]), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.character.m_Name))])])], 1), _c('Status', {
    staticClass: "pa-4 pb-8",
    staticStyle: {
      "max-width": "320px"
    },
    attrs: {
      "status": _vm.status,
      "divide": "2"
    }
  })], 1), _c('v-col', {
    staticClass: "hidden-xl-only",
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "pr-4",
    attrs: {
      "align": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.characard.format(_vm.evolvedID(_vm.evolution)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "min-width": "100",
      "max-width": "187.5",
      "aspect-ratio": 3 / 4,
      "src": _vm.$asset.characard.format(_vm.evolvedID(_vm.evolution)) + '.jpg'
    }
  })], 1)])]), _c('v-col', {
    staticClass: "hidden-lg-and-down",
    attrs: {
      "cols": "3"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.character.m_Rare != 2,
      expression: "character.m_Rare!=2"
    }],
    staticClass: "pr-4"
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.characard.format(_vm.evolvedID(0)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "min-width": "100",
      "max-width": "187.5",
      "aspect-ratio": 3 / 4,
      "src": _vm.$asset.characard.format(_vm.evolvedID(0)) + '.jpg'
    }
  })], 1)])]), _c('v-col', {
    staticClass: "hidden-lg-and-down",
    attrs: {
      "cols": "3"
    }
  }, [_c('div', {
    staticClass: "pr-4"
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.characard.format(_vm.evolvedID(_vm.maxEvolution)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "min-width": "100",
      "max-width": "187.5",
      "aspect-ratio": 3 / 4,
      "src": _vm.$asset.characard.format(_vm.evolvedID(_vm.maxEvolution)) + '.jpg'
    }
  })], 1)])])], 1), _c('div', {
    staticClass: "px-4"
  }, [_c('v-slider', {
    attrs: {
      "min": "1",
      "max": _vm.maxLevel
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "d-inline-block slider-label"
        }, [_c('span', [_vm._v(_vm._s(_vm.$t('Level')) + ":")]), _c('div', {
          staticClass: "float-right"
        }, [_vm._v(_vm._s(_vm.level))])])];
      },
      proxy: true
    }, {
      key: "append",
      fn: function fn() {
        return [_c('v-icon', {
          on: {
            "click": _vm.clickMax
          }
        }, [_vm._v("mdi-chevron-double-up")])];
      },
      proxy: true
    }, {
      key: "thumb-label",
      fn: function fn(props) {
        return [_vm._v(_vm._s(_vm.exp))];
      }
    }]),
    model: {
      value: _vm.level,
      callback: function callback($$v) {
        _vm.level = $$v;
      },
      expression: "level"
    }
  }), _c('v-slider', {
    attrs: {
      "min": "0",
      "max": _vm.maxFacilities
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "d-inline-block slider-label"
        }, [_c('span', [_vm._v(_vm._s(_vm.$t('Facilities')) + ":")]), _c('div', {
          staticClass: "float-right"
        }, [_vm._v(_vm._s(_vm.facilitiesManual ? '…' : _vm.facilities))])])];
      },
      proxy: true
    }, {
      key: "append",
      fn: function fn() {
        return [_c('v-icon', {
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              _vm.dialog = true;
            }
          }
        }, [_vm._v("mdi-dots-horizontal")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.facilities,
      callback: function callback($$v) {
        _vm.facilities = $$v;
      },
      expression: "facilities"
    }
  }), _c('v-slider', {
    attrs: {
      "min": "0",
      "max": "10"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "d-inline-block slider-label"
        }, [_c('span', [_vm._v(_vm._s(_vm.$t('Orb')) + ":")]), _c('div', {
          staticClass: "float-right"
        }, [_vm._v(_vm._s(_vm.orb))])])];
      },
      proxy: true
    }, {
      key: "append",
      fn: function fn() {
        return [_c('v-icon', {
          on: {
            "click": function click($event) {
              _vm.orb = 10;
            }
          }
        }, [_vm._v("mdi-chevron-double-up")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.orb,
      callback: function callback($$v) {
        _vm.orb = $$v;
      },
      expression: "orb"
    }
  }), _c('v-slider', {
    attrs: {
      "min": "0",
      "max": _vm.maxArousal
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "d-inline-block slider-label"
        }, [_c('span', [_vm._v(_vm._s(_vm.$t('Arousal')) + ":")]), _c('div', {
          staticClass: "float-right"
        }, [_vm._v(_vm._s(_vm.arousal))])])];
      },
      proxy: true
    }, {
      key: "append",
      fn: function fn() {
        return [_c('v-icon', {
          on: {
            "click": _vm.clickMin
          }
        }, [_vm._v("mdi-delete")])];
      },
      proxy: true
    }, {
      key: "thumb-label",
      fn: function fn(props) {
        return [_vm._v(_vm._s(_vm.arousalExp))];
      }
    }]),
    model: {
      value: _vm.arousal,
      callback: function callback($$v) {
        _vm.arousal = $$v;
      },
      expression: "arousal"
    }
  })], 1), _c('v-dialog', {
    attrs: {
      "max-width": "512"
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.$t('Facilities')))]), _c('v-card-text', [_c('v-slider', {
    attrs: {
      "max": _vm.maxFriendship
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "d-inline-block slider-label",
          staticStyle: {
            "width": "128px"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm.$t('Friendship')) + ":")]), _c('div', {
          staticClass: "float-right"
        }, [_vm._v(_vm._s(_vm.friendship))])])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.friendship,
      callback: function callback($$v) {
        _vm.friendship = $$v;
      },
      expression: "friendship"
    }
  }), _c('v-slider', {
    attrs: {
      "max": "10"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "d-inline-block slider-label",
          staticStyle: {
            "width": "128px"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm.$t('Title Facility')) + ":")]), _c('div', {
          staticClass: "float-right"
        }, [_vm._v(_vm._s(_vm.titleFacility))])])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.titleFacility,
      callback: function callback($$v) {
        _vm.titleFacility = $$v;
      },
      expression: "titleFacility"
    }
  }), _c('v-slider', {
    attrs: {
      "max": "10"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "d-inline-block slider-label",
          staticStyle: {
            "width": "128px"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm.$t('Class Facility')) + ":")]), _c('div', {
          staticClass: "float-right"
        }, [_vm._v(_vm._s(_vm.classFacilities[0]))])])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.classFacilities[0],
      callback: function callback($$v) {
        _vm.$set(_vm.classFacilities, 0, $$v);
      },
      expression: "classFacilities[0]"
    }
  }), _c('v-slider', {
    attrs: {
      "max": "10"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "d-inline-block slider-label",
          staticStyle: {
            "width": "128px"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm.$t('Class Facility')) + ":")]), _c('div', {
          staticClass: "float-right"
        }, [_vm._v(_vm._s(_vm.classFacilities[1]))])])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.classFacilities[1],
      callback: function callback($$v) {
        _vm.$set(_vm.classFacilities, 1, $$v);
      },
      expression: "classFacilities[1]"
    }
  }), _c('v-slider', {
    attrs: {
      "max": "10"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "d-inline-block slider-label",
          staticStyle: {
            "width": "128px"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm.$t('Class Facility')) + ":")]), _c('div', {
          staticClass: "float-right"
        }, [_vm._v(_vm._s(_vm.classFacilities[2]))])])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.classFacilities[2],
      callback: function callback($$v) {
        _vm.$set(_vm.classFacilities, 2, $$v);
      },
      expression: "classFacilities[2]"
    }
  })], 1)], 1)], 1), _c('v-list-item', {
    attrs: {
      "to": "/named/".concat(this.character.m_NamedType)
    }
  }, [_c('v-list-item-title', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Profile')))]), _c('v-list-item-action', {
    staticClass: "ma-0"
  }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$i18n.locale == 'ja',
      expression: "$i18n.locale=='ja'"
    }],
    attrs: {
      "target": "_blank",
      "href": _vm.$const.wikiwiki.character.format(_vm.$store.state.$db.NamedList[this.character.m_NamedType].m_FullName)
    }
  }, [_c('v-list-item-title', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.$store.state.$db.NamedList[this.character.m_NamedType].m_FullName) + " - " + _vm._s(_vm.$t('Wikiwiki.Title')))]), _c('v-list-item-action', {
    staticClass: "ma-0"
  }, [_c('v-icon', [_vm._v("mdi-open-in-new")])], 1)], 1), _vm.character.isDistributed ? _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$i18n.locale == 'ja',
      expression: "$i18n.locale=='ja'"
    }],
    attrs: {
      "target": "_blank",
      "href": _vm.$const.wikiwiki._.format('配布キャラについて')
    }
  }, [_c('v-list-item-title', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s('配布キャラについて') + " - " + _vm._s(_vm.$t('Wikiwiki.Title')))]), _c('v-list-item-action', {
    staticClass: "ma-0"
  }, [_c('v-icon', [_vm._v("mdi-open-in-new")])], 1)], 1) : _vm._e(), _c('v-divider'), _c('Ad', {
    key: "character-ad-".concat(_vm.id)
  }), _c('Illust', {
    attrs: {
      "id": _vm.id
    }
  }), _c('v-divider', {
    staticClass: "mb-4"
  }), _c('p', {
    staticClass: "title px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Skills')))]), _c('Skill', {
    key: "character-unique-skill",
    attrs: {
      "sp": "",
      "id": _vm.evolvedCharacter.m_CharaSkillID,
      "owner": "PL",
      "element": _vm.character.m_Element,
      "max": _vm.maxSkillLevel + _vm.arousalLevel.m_SkillLvLimit
    }
  }), _vm._l(_vm.evolvedCharacter.m_ClassSkillIDs, function (classSkillID, j) {
    return _c('Skill', {
      key: "character-class-skill-".concat(j),
      attrs: {
        "id": classSkillID,
        "owner": "PL",
        "element": _vm.character.m_Element,
        "max": _vm.maxSkillLevel
      }
    });
  }), _c('Skill', {
    attrs: {
      "id": _vm.character.m_Class + 1,
      "owner": "PL",
      "element": _vm.character.m_Element,
      "max": "1"
    }
  }), _c('Weapons', {
    attrs: {
      "id": _vm.evolvedID(_vm.maxEvolution)
    }
  }), _c('v-divider'), _c('Ad', {
    key: "character-ad-".concat(_vm.id, "-1")
  }), _c('Achievements', {
    attrs: {
      "id": _vm.id
    }
  }), _c('Flavor', {
    attrs: {
      "id": _vm.id
    }
  }), _c('Related', {
    attrs: {
      "id": _vm.id
    }
  }), _c('RelatedNamed', {
    attrs: {
      "id": _vm.character.m_NamedType,
      "hideTitle": ""
    }
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }